'use client';

import { DataFiltersProvider } from '@/components/filters/use-data-filters';
import StripeRequirementsBanner from '@/components/stripe/StripeRequirementsBanner';
import { StripeProvider, useStripeContext } from '@/components/stripe/context';
import { PrivateRoute } from '@instamenu/routes';
import { Box } from '@instamenu/ui-system-next';
import { Sidebar } from '../../components/sidebar/Sidebar';
import { Header } from '@/components/header';
import * as styles from './layout.css';
import { sidebarWidth } from '@/components/sidebar/Sidebar.css';
import { useSidebarResize } from '@instamenu/react-hooks';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '@instamenu/ui-vanilla-extract';
import { useState } from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import clsx from 'clsx';

function LayoutContent({ children }: { children: React.ReactNode }) {
  const { showRequirementsBanner } = useStripeContext();
  const isDesktop = useMediaQuery({ query: breakpoints.desktop });
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { width, handleMouseDown, setWidth } = useSidebarResize();

  return (
    <Box
      className={styles.layoutWrapper}
      style={assignInlineVars({
        [sidebarWidth]: isDesktop ? `${width}px` : '100%',
      })}
    >
      <Sidebar
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        handleMouseDown={handleMouseDown}
      />

      <Box className={styles.mainContent} css={{ marginLeft: isDesktop && !width ? 12 : 0 }}>
        <Header
          isDesktop={isDesktop}
          setIsMobileOpen={setIsMobileOpen}
          width={width}
          setWidth={setWidth}
        />
        <main
          className={clsx(
            styles.centeredGrid,
            showRequirementsBanner && styles.contentShiftAnimation,
          )}
        >
          <StripeRequirementsBanner className={styles.fullWidth} />
          <DataFiltersProvider>{children}</DataFiltersProvider>
        </main>
      </Box>
    </Box>
  );
}

export default function PrivateLayout({ children }: { children: React.ReactNode }) {
  return (
    <PrivateRoute>
      <StripeProvider>
        <LayoutContent>{children}</LayoutContent>
      </StripeProvider>
    </PrivateRoute>
  );
}
